module.exports = __webpack_public_path__ + "static/img/khfw11-en.c3b5bba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/customer_service/khfw11-en.jpg
// module id = qi4L
// module chunks = 3